import React, { useState } from "react";
import { HXCircleIcon, OnboardDueDateCard } from "@aph/ui-lib-humanx";
import Picker from "@/components/Picker";
import styles from "@/components/PageHome/components/OnboardingSection/Flows/Flows.module.scss";
import { CYCLE_OPTIONS } from "@/components/PageHome/constants";

interface PeriodCycleProps {
  heading?: any;
  description?: any;
  bgIcon?: React.ReactNode;
  ctaText?: string;
  ctaClick: (cycleLength: number) => void;
  ctaBelowText?: any;
  initialValue?: any;
  showEdgeCases?: boolean;
}

const initialData = {
  heading: {
    prefixText: (
      <span>
        How long is <strong>your average cycle?</strong>
      </span>
    ),
  },
  description: "",
  bgIcon: <HXCircleIcon iconStyle={"style1"} className={styles["bgIconTopRight"]} />,
  ctaText: "Submit",
  ctaBelowText: "",
  initialValue: CYCLE_OPTIONS.find((option) => option.default)?.value,
};

const PeriodCycle: React.FC<PeriodCycleProps> = (props) => {
  const {
    heading = initialData.heading,
    description = initialData.description,
    bgIcon = initialData.bgIcon,
    ctaText = initialData.ctaText,
    ctaClick,
    ctaBelowText = initialData.ctaBelowText,
    initialValue = initialData.initialValue,
    showEdgeCases = true,
  } = props;
  const [option, setOption] = useState<number>(initialValue);

  const handleSubmit = (): void => {
    if (ctaClick && typeof ctaClick === "function") {
      ctaClick(option);
    }
  };

  const handleOptionChange = (date: number): void => {
    setOption(date);
  };

  return (
    <>
      <OnboardDueDateCard
        titleText={heading}
        subTitleText={description}
        backgroundCard={bgIcon}
        middleSection={
          <Picker
            fullWidth={false}
            initialValue={initialValue}
            options={showEdgeCases ? CYCLE_OPTIONS : CYCLE_OPTIONS.slice(1, -1)}
            setOption={handleOptionChange}
          />
        }
        ctaText={ctaText}
        ctaClick={handleSubmit}
        ctaBelowText={ctaBelowText}
      />
    </>
  );
};

export default PeriodCycle;
